import { useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { procuringEntityKeys } from "@/lib/query-keys";
import type { ProcuringEntity } from "@/types/domain";

export function useProcuringEntities(search: string) {
  return useQuery({
    queryKey: procuringEntityKeys.search(search),
    enabled: search.trim().length >= 2,
    queryFn: async () => {
      const query = buildQuery({ search });
      const res = await fetchToBackend<any>(
        `/contractings/procuring-entities${query}`,
      );
      return (res?.data ?? res ?? []) as ProcuringEntity[];
    },
  });
}
